import React, {useEffect, useRef} from 'react';
import {connect} from "react-redux";
import isLoggedIn from '../../actions/isLoggedIn';
import {Layout} from "antd";
import PrivateHeader from "../Layouts/Private/PrivateHeader";
import PublicHeader from "../Layouts/Public/PublicHeader";
import PrivateSider from "../Layouts/Private/PrivateSider";
import {Route,withRouter,Switch} from "react-router-dom";
import Login from "../Login/Login";
import {Loading} from "../Loading/Loading";
import Notification from "../Notification/Notification";
import authorization from "./authorization";
import {
    ADMIN_ROUTE,
    CERTIFICATE_REQUEST_PKCS10_ROUTE,
    CERTIFICATE_REQUEST_ROUTE,
    CHANGE_PASSWORD_ROUTE,
    GENERATE_P12_ROUTE,
    MAIN_ROUTE,
    RECOVER_PASSWORD_ROUTE, REPORTS_ROUTE
} from "./routes";
import GenerateCertP12 from "../GenerateCertP12/GenerateCertP12";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import ChangePassword from "../ChangePassword/ChangePassword";
import NotFound from "../NotFound";
import CertificatesList from "../CertificatesList/CertificatesList";
import Modal from "../Modal/Modal";
import CertRequest from "../CertRequest/CertRequest";
import CertRequestPKCS10 from "../CertRequestPKCS10/CertRequestPKCS10";
import Admin from "../Admin";
import Report from "../Report";


const AuthorizedHeader = authorization(PrivateHeader);

const AppContainer = (props) => {

    const logged=props.logged;
    const localProps=useRef(props);
    useEffect(() => {
      if(logged === null)
          localProps.current.isLoggedIn();
  },[logged]);

  return (
      <Layout className={'h-100 w-100'}>
          <Modal/>
          <Loading language={props.language}/>
          <Notification/>
          <PrivateSider/>
          <Layout>
              <AuthorizedHeader/>
              <PublicHeader/>
              <Layout.Content>
                  <div className={'h-100'}>
                      <Switch>
                          <Route path='/' exact component={Login}/>
                          <Route path={GENERATE_P12_ROUTE} exact component={GenerateCertP12}/>
                          <Route path={RECOVER_PASSWORD_ROUTE} exact component={ForgotPassword}/>
                          <Route path={CHANGE_PASSWORD_ROUTE} exact component={ChangePassword}/>
                          <Route path={MAIN_ROUTE} exact component={CertificatesList} />
                          <Route path={CERTIFICATE_REQUEST_ROUTE} exact component={CertRequest} />
                          <Route path={CERTIFICATE_REQUEST_PKCS10_ROUTE} exact component={CertRequestPKCS10} />
                          <Route path={ADMIN_ROUTE} exact component={Admin} />
                          <Route path={REPORTS_ROUTE} exact component={Report} />
                          <Route component={NotFound}/>
                      </Switch>
                  </div>
              </Layout.Content>

          </Layout>
      </Layout>
  );
  
};


function mapStateToProps(state) {
    return {
    logged: state.auth.logged,
        language:state.auth.language

  }
}

export default withRouter(connect(mapStateToProps, {isLoggedIn})(AppContainer));